import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { HeadingBoundary } from 'components/Heading';
import { HeadingContent } from 'patterns/HeadingContent';
import { Media } from 'patterns/Media';
import { SectionHeader } from 'patterns/SectionHeader';
import { ProductList } from 'patterns/ProductList';
import { cx } from 'utility';
import * as styles from './ProductBlock.module.scss';

const propTypes = {
    className: PropTypes.string,
    content: PropTypes.array,
    media: PropTypes.array,
    overline: PropTypes.string,
    products: PropTypes.array,
    title: PropTypes.string,
};

const defaultProps = {
    className: '',
    content: [],
    media: [],
    overline: '',
    products: [],
    title: '',
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['productBlock'],
    );

    return classes || undefined;
}

function ProductBlock({
    className,
    content,
    media,
    overline,
    products,
    title,
}) {
    const classes = getClasses({ className });

    return (
        <div className={classes}>
            <HeadingBoundary>
                <Grid className={styles['grid']} block={true}>
                    {overline && (
                        <SectionHeader
                            title={overline}
                            type="simple"
                        />
                    )}
                    <HeadingContent
                        content={content}
                        title={title}
                    />
                    <Media
                        items={media}
                    />
                    <ProductList
                        items={products}
                    />
                </Grid>
            </HeadingBoundary>
        </div>
    );
}

ProductBlock.propTypes = propTypes;
ProductBlock.defaultProps = defaultProps;

export { ProductBlock };
